import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useMemo, useState } from 'react';

function useGoogleMapsAutocompleteService() {
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [autocompleteSessionToken, setAutocompleteSessionToken] = useState();

  const PlacesLibrary = useMapsLibrary('places');
  const isAutocompleteServiceLoaded = useMemo(
    () => autocompleteService != null,
    [autocompleteService]
  );

  useEffect(() => {
    if (!PlacesLibrary) return;
    const service = new PlacesLibrary.AutocompleteService();

    if (service != null) {
      setAutocompleteService(service);
    }

    const token = new PlacesLibrary.AutocompleteSessionToken();

    if (token != null) {
      setAutocompleteSessionToken(token);
    }
  }, [PlacesLibrary]);

  return {
    isAutocompleteServiceLoaded,
    autocompleteService,
    autocompleteSessionToken,
  };
}

export { useGoogleMapsAutocompleteService };
